export const DATA_ENTRY_ENDPOINTS = {
  FRAMEWORKS: "/frameworks",
  DISCLOSURES: "/disclosures",
  MASTER_DATA_DISCLOSURES: "/esg-master-data/disclosures",
  DATA_ENTRIES: (id) => `/data-entries${id ? `/${id}` : ""}`,
  DATA_ENTRIES_BY_DISCLOSURE: (disclosureId) =>
    `/data-entries/disclosure/${disclosureId}`,
  DATA_ENTRIES_BY_DISCLOSURE_COMPUTED: (disclosureId) =>
    `/data-entries/disclosure/${disclosureId}/computed`,
  DATA_ENTRIES_BY_ORG_YEAR: (disclosureId) =>
    `/data-entries/disclosure/${disclosureId}/entries`,
  DATA_ENTRIES_BULK: `/data-entries/bulk`,
  DATA_ENTRIES_BULK_DELETE: `/data-entries/bulk-delete`,
  FILES_UPLOAD_BATCH: (companyId) => `/files/upload/batch/${companyId}`,
  FILES_DELETE: (fileId) => `/files/${fileId}`,
  ASSIGNMENTS: (id) => `/data-entry-assignments${id ? `/${id}` : ""}`,
  PREFILL_SUGGESTIONS: (disclosureId) =>
    `/data-entries/disclosure/${disclosureId}/prefill-suggestions`,
  NXMAP_IMPORT_PREVIEW: "/data-entries/nxmap-import/preview",
  NXMAP_SYNC: "/data-entries/nxmap-sync",
  NXMAP_SYNC_BULK_PREVIEW: "/data-entries/nxmap-sync-bulk/preview",
  NXMAP_SYNC_BULK_CONFIRM: "/data-entries/nxmap-sync-bulk/confirm",
  NXMAP_SYNC_SINGLE: (entryId) => `/data-entries/${entryId}/nxmap-sync`,
  DATA_ENTRIES_LIST: "/data-entries",
  COMPUTED_DISCLOSURES_LIST: "/data-entries/computed",
  DATA_ENTRIES_OVERVIEW: "/data-entries/overview",
  DATA_ENTRIES_CONSOLIDATED: "/data-entries/consolidated",
  DATA_ENTRIES_CONSOLIDATED_BREAKDOWN: "/data-entries/consolidated/breakdown",
  DISCLOSURE_PRESENCE: "/data-entries/disclosure-presence",
  BATCH_UPLOAD_TEMPLATE: "/data-entries/batch-upload/template",
  BATCH_UPLOAD_YEARS: "/data-entries/batch-upload/years",
  BATCH_UPLOAD_FILTER_OPTIONS: "/data-entries/batch-upload/filter-options",
  BATCH_UPLOAD_PARSE: "/data-entries/batch-upload/parse",
  BATCH_UPLOAD_CONFIRM: "/data-entries/batch-upload/confirm",
};
